import { CartOrder, CartOrderItem } from 'cart-core/src';
import getCurrentCurrency from 'cart-ui/src/service/getCurrentCurrency';
import { GtagFunction } from 'google-analytics';

const NAMESPACE = 'reliv-analytics';

/**
 * This is responsible for transmitting the "purchase" google analytics event.
 * Other events are transmitted from other places.
 *
 * We had to stop transmitting "add_to_cart" from here because trying to
 * do it while avoiding redirect race conditions was too complicated
 * to do here. "add_to_cart" transmission was moved to the order manager.
 */
export default class ECommerceEnhanced {

    public events;

    constructor(
        public gtag: GtagFunction,
        public orderMgr
    ) {
        this.events = orderMgr.getEventManager();

        this.events.on(
            'orderMgr.processNonCurrentOrder.success.sendThirdPartyAnalytics',
            this.trackOrderComplete.bind(this),
            NAMESPACE
        );
    }

    /**
     * trackOrderComplete
     * @param response
     */
    public async trackOrderComplete(
        response: { data: CartOrder }
    ) {
        const order = response.data;

        const currency = await getCurrentCurrency()
        this.gtag('event', 'purchase', {
            coupon: order.attributes?.couponCodeId ?? null,
            currency,
            items: order.items.map((item: CartOrderItem) => ({
                id: item.skuNumber,
                name: item.name,
                price: item.price,
                quantity: item.qty,
            })),
            shipping: order.orderTotals.shipping,
            tax: order.orderTotals.tax,
            transaction_id: order.orderNumber,
            value: order.orderTotals.total,
        });
    }
}
